import { CloseOutlined } from "@ant-design/icons";
import { Form, FormInstance, FormProps, Input, Modal, TreeSelect, Select, Switch } from "antd";
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from "react";
// import * as UnitApi from '../../../api/unit/unitApi';
import useToast from "../../../hook/useToast";
import './style.scss';
import { mixPostV2, mixGetV2 } from '../../../services/mixin'
import { json } from "stream/consumers";
interface ModalProps {
  isOpen: boolean
  data: []
  closeModal: () => void
  editData?: any
  modalFinish?: () => void
  source?: any,
  keyConfiguration?: any,
  categorySourceColumnWarehouses?: any,
  groupId?: number
}
const ModalCreate: React.FC<ModalProps> = ({
  isOpen,
  data,
  closeModal,
  editData,
  modalFinish,
  source,
  keyConfiguration,
  categorySourceColumnWarehouses,
  groupId
}) => {
  const [form] = useForm();
  const formRef = useRef<FormInstance>(null);
  const pushToast = useToast();
  const [editDataJson, setEditDataJson] = useState<any>(editData ? editData.json : [])
  const [categorySourceColumnWarehousesState, setCategorySourceColumnWarehousesState] = useState([] as any)
  useEffect(() => {
    const filteredCategory = (categorySourceColumnWarehouses ?? []).filter((item: any) => item.category_source_group_id === groupId)
    setCategorySourceColumnWarehousesState(filteredCategory)
  }, [groupId, editData])

  const submitForm = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };
  const [loading, setLoading] = useState(false)
  const onFinish: FormProps["onFinish"] = async (values) => {
    const listSource = [] as any
    if (values.system && values.system.length > 0) {
      values.system.map((val: any) => {
        const findData = editData.params_key.find((x: any) => x.source_id === val)
        if (findData) {
          listSource.push({
            params_key_id: findData.id,
            source_id: val,
          })
          return true
        } else {
          listSource.push({
            params_key_id: 0,
            source_id: val,
          })
        }

        return true
      })
    }

    const listCategory = [] as any
    values.category.map((val: any) => {
      const findData = editData.category_column_source_column.find((x: any) => x.category_source_column_warehouse_id === val)
      if (findData) {
        listCategory.push({
          category_column_source_column_id: findData.id,
          category_source_column_warehouse_id: val,
        })
        return true
      } else {
        listCategory.push({
          category_column_source_column_id: 0,
          category_source_column_warehouse_id: val,
        })
      }

      return true
    })

    const param = {
      name: values.name,
      note: values.note == undefined || values.note === 'undefined' || values.note === null || values.note === 'null' ? '' : values.note,
      code: values.code,
      _method: 'PUT',
      list_category_source_column_id: JSON.stringify(listCategory),
    } as any
    if (groupId === 3) {
      param.json = JSON.stringify(editDataJson)
      param.list_source_id = JSON.stringify(listSource)
      param.is_required = values.is_required ? 1 : 0
    }
    setLoading(true)
    const res = await mixPostV2(`/api/v1/be/source_column_warehouse/${editData?.id}`, param)
    if (res.status) {
      pushToast("Thao tác thành công", "success")
      setLoading(false)
      formRef?.current?.resetFields()
      if (modalFinish) {
        modalFinish()
      }
    } else {
      pushToast("Error!", "warning")
      setLoading(false)
    }
  };

  useEffect(() => {
    formRef?.current?.setFieldsValue({
      name: editData.name,
      note: editData.note,
      code: editData.code,
      column: editData?.column_warehouse?.column,
      system: editData?.params_key?.map((item: any) => item.source_id) || [],
      category: editData?.category_column_source_column?.map((item: any) => item.category_source_column_warehouse_id) || [],
      is_required: editData.is_required === 1 ? true : false,
    })
    setEditDataJson(editData ? editData.json : [])
  }, [editData])

  const [paramListData, setParamListData] = useState({
    'sort[]': 'is_active,desc',
    page: 1,
    limit: 100000,
    name: '',
    source_id: null,
  } as any)
  let wait = false
  const [listData, setListData] = useState([])
  const getListData = async () => {
    if (wait) {
      return
    }
    wait = true
    const res = await mixGetV2('/api/v1/be/source_column_warehouses', paramListData)
    if (res.status) {
      const temp = [] as any
      res.data.items.map((val: any) => {
        temp.push({
          ...val,
          json: JSON.parse(val.json || '[]'),
          note: val.note === 'undefined' ? '' : val.note,
        })
        return true
      })
      setListData(temp)
    }
  }

  useEffect(() => {
    getListData()
  }, [paramListData])

  const [tagInputAction, setTagInputAction] = useState(false)
  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">Param hệ thống</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal modal-content-creat-area ant-modal-size"
      closeIcon={false}
      footer={<div className="bg-FCFCFD d-flex justify-end align-center py-2 px-6 w-full border-t-F0F0F0 gap-2">
        <button className="text-sm text-344054 border-F2F4F7 bg-white h-8 px-15-px font-regular rounded-2 shadow-btn-save" onClick={closeModal}>Đóng</button>
        <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px font-regular shadow-btn-save"
          onClick={submitForm}>
          Lưu
        </button>
      </div>}
    >
      <Form
        form={form}
        ref={formRef}
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <div className="d-flex flex-column gap-18-px p-6">
          {/* <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Mã Param</p>
            <Form.Item
              name="column"
              rules={[{ required: true, message: 'Nhập mã Param!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                disabled
                placeholder="Mã Param"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div> */}
          {/* <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Mã</p>
            <Form.Item
              name='code'
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn mã'
                }
              ]}
            >
              <Select
                className='rs-select'
                placeholder='Chọn mã'
                showSearch
                allowClear
                filterOption={(input, option) => {
                  const normalize = (s: any) =>
                    String(s ?? '')
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .replace(/đ/g, 'd')
                      .replace(/Đ/g, 'D')
                      .toLowerCase()

                  const label = option?.label ?? option?.children ?? option?.value ?? ''
                  return normalize(label).includes(normalize(input))
                }}
                options={keyConfiguration ? keyConfiguration.map((val: any) => ({ label: val.value_key, value: val.name_key })) : []}
              />
            </Form.Item>
          </div> */}

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Mã</p>
            <Form.Item
              name="code"
              rules={[{ required: true, message: 'Nhập Mã!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Mã"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Tên Param</p>
            <Form.Item
              name="name"
              rules={[{ required: true, message: 'Nhập tên Param!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Tên Param"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>
          {groupId === 3 &&
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054">Excel mapping</p>
              <div className="list-tag-excel">
                {editDataJson.map((item: any, index: number) => (
                  <div key={index} className="tag-item">
                    <div className="text">{item}</div>
                    <div className="icon-svg delete-icon" onClick={() => {
                      const newList = [...(editDataJson || [])];
                      newList.splice(index, 1);
                      formRef?.current?.setFieldsValue({ json: newList });
                      // Cập nhật editData nếu cần thiết
                      setEditDataJson(newList);
                    }}>
                      <CloseOutlined />
                    </div>
                  </div>
                ))}
                <div className="tag-item-input">
                  {tagInputAction ? (
                    <Input
                      autoFocus
                      className="input-tag"
                      onBlur={(e) => {
                        const value = e.target.value.trim();
                        const findData = listData.find((x: any) => x.json.includes(value)) as any
                        if (findData && value) {
                          pushToast(`Giá trị (${value}) đã được gán cho Param "${findData.name}"`, "warning")
                          setTagInputAction(false);
                          return;
                        }
                        if (value) {
                          const newList = [...(editDataJson || []), value];
                          formRef?.current?.setFieldsValue({ json: newList });
                          // Cập nhật editData nếu cần thiết
                          setEditDataJson(newList);
                        }
                        setTagInputAction(false);
                      }}
                      onPressEnter={(e) => {
                        const value = (e.target as HTMLInputElement).value.trim();
                        const findData = listData.find((x: any) => x.json.includes(value)) as any
                        if (findData) {
                          pushToast(`Giá trị "${value}" đã được gán cho Param "${findData.name}"`, "warning")
                          setTagInputAction(false);
                          return;
                        }
                        if (value) {
                          const newList = [...(editDataJson || []), value];
                          formRef?.current?.setFieldsValue({ json: newList });
                          // Cập nhật editData nếu cần thiết
                          setEditDataJson(newList);
                        }
                        setTagInputAction(false);
                      }}
                    />
                  ) : (
                    <span onClick={() => setTagInputAction(true)}>+ Thêm</span>
                  )}
                </div>
              </div>
            </div>
          }

          {/* <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Ghi chú</p>
            <Form.Item
              name="note"
              className="m-none-form-item text-explan"
            >
              <Input.TextArea
                placeholder="Ghi chú"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2 font-regular input-custom h-8"
              />
            </Form.Item>
          </div> */}
          {groupId === 3 &&
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054">Hệ thống</p>
              <Form.Item
                name='system'
                className="m-none-form-item text-explan"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng chọn hệ thống'
                  }
                ]}
              >
                <Select
                  className='rs-select v2'

                  placeholder='Chọn hệ thống'
                  mode='multiple'
                  options={source ? source.map((val: any) => ({ label: val.name, value: val.id })) : []}
                />
              </Form.Item>
            </div>
          }

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Nhóm</p>
            <Form.Item
              name='category'
              className="m-none-form-item text-explan"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn nhóm'
                }
              ]}
            >
              <Select
                className='rs-select v2'
                placeholder='Chọn nhóm'
                mode='multiple'
                options={categorySourceColumnWarehousesState ? categorySourceColumnWarehousesState.map((val: any) => ({ label: val.name, value: val.id })) : []}
                filterOption={(input, option) => {
                  const normalize = (s: any) =>
                    String(s ?? '')
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .replace(/đ/g, 'd')
                      .replace(/Đ/g, 'D')
                      .toLowerCase()

                  const label = option?.label ?? ''
                  return normalize(label).includes(normalize(input))
                }}
              />
            </Form.Item>
          </div>
          {groupId === 3 &&
            <div className="d-flex flex-column gap-1">
              <Form.Item
                name='is_required'
                label='Giá trị bắt buộc'
                valuePropName="checked"
                layout='horizontal'
                className="m-none-form-item text-explan"
              >
                <Switch className='rs-switch' />
              </Form.Item>
            </div>
          }
        </div>
      </Form>
    </Modal>
  )
}
export default ModalCreate
